import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsMainPageMixin extends Vue {
  get isMainPage() {
    return this.$route.path === '/';
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isMainPage.ts